/**
 * useAdobeTarget
 */

import { useCallback, useMemo } from 'react';
import {
    Queries,
    Mutations,
    ApolloLib,
} from 'bdvp-graphql';

import { getAdobeTarget } from '../../utils';

const {
    useMutation,
    useQuery,
} = ApolloLib;
const { GET_TARGET_OFFER } = Queries;
const { SET_TARGET_OFFER } = Mutations;

const useAdobeTarget = (config = {}, testKey) => {

    const tests = config.tests ?? {};
    const {
        enabled: isTestEnabled = false,
        key: payloadKey,
    } = tests[testKey] ?? {};
    const [setTargetOfferMutation] = useMutation(SET_TARGET_OFFER);
    const loadTargetOffer = useCallback(
        async() => {

            const targetOffer = await getAdobeTarget(config);
            setTargetOfferMutation({
                variables: {
                    targetOffer,
                },
            });

        },
        [
            setTargetOfferMutation,
            config,
        ]
    );

    const { data: { targetOffer: targetOfferString } = {} } = useQuery(GET_TARGET_OFFER);
    const targetOffer = useMemo(() => targetOfferString && JSON.parse(targetOfferString), [targetOfferString]);
    const loading = typeof targetOffer === 'undefined';
    const enabled = (config.enabled && isTestEnabled) ?? false;
    const payload = useMemo(() => {

        if(!enabled || loading) {

            return;

        }

        const targetOfferContent = (Array.isArray(targetOffer) && targetOffer[0]?.content) ?? [];
        const selectedPayload = targetOfferContent.find(payload => typeof payload[payloadKey] !== 'undefined') ?? {};
        return selectedPayload[payloadKey];

    }, [
        targetOffer,
        payloadKey,
        enabled,
        loading,
    ]);

    return {
        loadTargetOffer,
        loading,
        targetOffer,
        payload,
        enabled,
    };

};

export default useAdobeTarget;
